export default __webpack_public_path__ + "static/media/SWT1880.34I-40512_-23960_0.6c9cdb5d.jpg";